module.exports = "<h1>System Locking</h1>\r\n\r\n<div class=\"alert alert-success\" *ngIf=\"complete\">System unlocked!</div>\r\n\r\n<p>\r\n    Run to remove a System Lock for the institution specified.\r\n</p>\r\n\r\n<button class=\"btn btn-primary\" (click)=\"unlockSystem()\">Run</button>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/system/systemlock.html
 ** module id = 684
 ** module chunks = 0
 **/